'use strict';

const isPlainObject = require('./rlink-type-utils/isPlainObject');

class InspectableError extends Error {
  constructor (message, inspectableValues) {
    super(message);
    this.inspectableValues = inspectableValues;
    if (typeof console !== 'undefined') {
      console.error('InspectableError values:', this.inspectableValues);
    }
  }
}

// deal with printing symbols
function valueString (val) {
  try {
    return String(val);
  } catch (e) {
    console.warn('valueString converstion warning:', e);
    return '<unprintable>';
  }
}

function inspectable (strings, ...values) {
  let inspectableValues = {};
  let stringValues = values.map(val => {
    let stringVal = val;
    if (isPlainObject(val)) {
      let [[label, value], ...rest] = Array.from(Object.entries(val));
      if (rest.length === 0) {
        stringVal = `${label}=${valueString(value)}`;
        inspectableValues[label] = value;
      }
    }
    return valueString(stringVal);
  });
  return new InspectableError(String.raw(strings, ...stringValues), inspectableValues);
}

module.exports = inspectable;
module.exports.InspectableError = InspectableError;



// WEBPACK FOOTER //
// ./lib/rlink-inspectable-error.js